import React, { Component } from 'react';
import styled from 'styled-components';
import { Button, Link } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { connect } from 'react-redux';
import { modalActions } from '../../../redux/root-action';
import ReactModalFooter from '../../Modal/ReactModalFooter';
import ReactModalHeader from '../../Modal/ReactModalHeader';
import ReactModalContent from '../../Modal/ReactModalContent';
import { modals, genderOptions } from '../../../utils/constants';
import { formatDate, formatAmountWithoutDecimals, keyDown } from '../../../utils/helpers';

const StyledFieldContainer = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px solid #e1e5e8;
  color: ${tokens.ColorGrey900};
  justify-content: space-between;
  @media only screen and (max-width: 767px) {
    margin-top: 16px;
  }
`;

const StyledInputLabel = styled.div`
  margin: 16px 32px 16px 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media only screen and (max-width: 767px) {
    height: auto;
    width: auto;
  }
`;

const StyledIntroLine = styled.div`
  font-size: 20px;
  margin-top: 32px;
  color: ${tokens.ColorGrey900};
  @media only screen and (max-width: 767px) {
    font-size: 16px;
    margin-top: 24px;
  }
`;

const StyledLink = styled.div`
  text-decoration: none;
  &:hover,
  &:focus {
    text-decoration: none;
  }
  margin: 32px 0px 32px 0px;
  display: flex;
  outline: none;
  @media only screen and (max-width: 767px) {
    margin: 32px 0px 32px 0px;
  }
`;

const StyledValue = styled.div`
  font-family: Nimbus Sans Bold;
  margin: 16px 0px 16px 0px;
  text-align: right;
  @media only screen and (max-width: 767px) {
    margin: 16px 0px 16px 0px;
  }
`;

const StyledSpan = styled.span`
  color: ${tokens.ColorGrey600};
`;

const StyledDelete = styled.div`
  display: flex;
  align-items: center;
  button {
    cursor: pointer;
    padding-left: 0;
  }
  img {
    width: 24px;
    height: 24px;
  }
`;

class EditSpouseProfile extends Component<any, any> {
  showAddEditSpouseProfileModal = () => {
    const { showModal } = this.props;
    showModal(modals.ADD_SPOUSE_PROFILE);
  };

  showDeleteSpouseModal = () => {
    const { showModal } = this.props;
    showModal(modals.DELETE_SPOUSE_MODAL);
  };

  showAddEditSpouseProfileModalOnKeyPress = (e: any) => {
    if (e.nativeEvent.code === 'Enter') {
      this.showAddEditSpouseProfileModal();
    }
  };

  render(): JSX.Element {
    const {
      firstName,
      lastName,
      birthDateObj,
      gender,
      currentSalary,
      spouseRetirementStartAge,
      spouseSocialSecurityStartAge,
    } = this.props.spouse;
    const mq = window.matchMedia('(max-width: 767px)');
    return (
      <React.Fragment>
        <ReactModalHeader modalTitle="Spouse Profile" showClose={true} />
        <ReactModalContent>
          <StyledIntroLine tabIndex={0}>
            This information is included in your retirement savings balances and projections throughout the site. Make
            sure it’s up to date.
          </StyledIntroLine>
          <StyledLink
            tabIndex={0}
            onClick={this.showAddEditSpouseProfileModal}
            onKeyPress={this.showAddEditSpouseProfileModalOnKeyPress}
          >
            <Link linkLabel="Edit profile details" customStyles={'font-family: Nimbus Sans Bold'} />
            <img
              width="16"
              height="16"
              style={{ marginLeft: 8 }}
              src={`data:image/svg+xml;base64,${tokens.AssetIconEdit}`}
              alt="edit icon"
            />
          </StyledLink>
          <StyledFieldContainer>
            <StyledInputLabel tabIndex={0}>Spouse Name </StyledInputLabel>
            <StyledValue tabIndex={0} className="blocked_data">
              {firstName} {lastName}{' '}
            </StyledValue>
          </StyledFieldContainer>
          <StyledFieldContainer>
            <StyledInputLabel tabIndex={0}>Birth Date</StyledInputLabel>
            <StyledValue tabIndex={0} className="blocked_data">
              {formatDate(birthDateObj)}
            </StyledValue>
          </StyledFieldContainer>
          <StyledFieldContainer>
            <StyledInputLabel tabIndex={0}>Male/Female</StyledInputLabel>
            <StyledValue tabIndex={0} className="blocked_data">
              {gender ? genderOptions[gender] : ''}
            </StyledValue>
          </StyledFieldContainer>
          <StyledFieldContainer>
            <StyledInputLabel tabIndex={0}>Current Salary</StyledInputLabel>
            <StyledValue tabIndex={0} className="blocked_data">
              {formatAmountWithoutDecimals(currentSalary)}
              <StyledSpan>&nbsp;/yr.</StyledSpan>
            </StyledValue>
          </StyledFieldContainer>
          <StyledFieldContainer>
            <StyledInputLabel tabIndex={0}>Retirement Age</StyledInputLabel>
            <StyledValue tabIndex={0}>{spouseRetirementStartAge}</StyledValue>
          </StyledFieldContainer>
          <StyledFieldContainer style={{ border: 'none' }}>
            <StyledInputLabel tabIndex={0}>Social Security Age</StyledInputLabel>
            <StyledValue tabIndex={0}>{spouseSocialSecurityStartAge}</StyledValue>
          </StyledFieldContainer>
        </ReactModalContent>
        <ReactModalFooter hideCancel={true} customStyles={'justify-content: flex-start'}>
          <StyledDelete>
            <Button
              type="textButton"
              title="Delete Spouse"
              fitContainerWidth={mq.matches ? true : false}
              icon={tokens.AssetIconDeleteOutline}
              marginLeftPx={0}
              onClick={this.showDeleteSpouseModal}
              tabIndex={0}
              onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.showDeleteSpouseModal)}
            />
          </StyledDelete>
        </ReactModalFooter>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ spouse }: any) => ({
  spouse: spouse.tempScenario,
});

export default connect(mapStateToProps, {
  hideModal: modalActions.hideModal,
  showModal: modalActions.showModal,
})(EditSpouseProfile);
